import GameSelector from './GameSelector';

export default GameSelector;
